import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import {
	CenteredCircle,
	GrowingDetailContainer,
	HamburgerContainer,
	Header,
	Main,
	MenuButtonContainer,
	MenuContainer,
	StyledCallIcon,
	StyledIconMenu,
} from '../easyclaim.app.components/index';
import theme from '../easyclaim.app.theme/theme';

import { ScreenComponent } from './ScreenComponent';

interface InsuranceExpertProps {
	onHelp: () => void;
	onMenu: () => void;
}

export class InsuranceExpert extends ScreenComponent<InsuranceExpertProps, {}> {
	constructor(props: InsuranceExpertProps) {
		super(props);

		this.state = {};
	}

	public render() {
		return (
			<div className="main-container">
				<Header>
					<MenuContainer>
						<MenuButtonContainer>
							<button className="button-secondary button-small" onClick={this.props.onHelp}>
								<FormattedMessage id="button.help" />
							</button>
						</MenuButtonContainer>
						<HamburgerContainer onClick={this.props.onMenu}>
							<StyledIconMenu />
						</HamburgerContainer>
					</MenuContainer>
				</Header>
				<Main>
					<h2 className="insurance-expert-title">
						<FormattedMessage id="insuranceExpert.headline" />
					</h2>
					<GrowingDetailContainer>
						<CenteredCircle
							size="6rem"
							borderColor={theme.colors.success}
							borderStyle="solid"
							borderWidth="3px"
						>
							<StyledCallIcon />
						</CenteredCircle>
						<Paragraph>
							<FormattedMessage id="insuranceExpert.description" />
						</Paragraph>
					</GrowingDetailContainer>
				</Main>
			</div>
		);
	}
}

const Paragraph = styled.p`
	margin-bottom: 1rem;
	hyphens: auto;
	user-select: none;
	cursor: default;
`;
